<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import { Button, Icon } from 'smelte'
  import { getLabel } from '../utils'
  import RedButton from '../RedButton.svelte'
  import { push } from 'svelte-spa-router'
  import ProjectData from './ProjectData.svelte'
  import DataTable from '../../DataTable/DataTable.svelte'
  import { installedBaseAPI } from '../api'
  import { ProgressCircular } from 'smelte'
  import { faFileAlt } from '@fortawesome/free-regular-svg-icons'
  import { selectedInstalledBase, userStore } from '../../../store'
  import { faList } from '@fortawesome/free-solid-svg-icons'
  import { arrayFilterByRoles } from '../../../roles'

  export let data = {no: 0}
  export let columns = []
  export let edit = false

  const dispatch = createEventDispatcher()
  const api = new installedBaseAPI()

  let actions = [
    {name: 'new-protocol', icon: faFileAlt, hint: 'New protocol', rule: (data)=>{return data.model === 'Conveyor'}},
    {name: 'protocols', icon: faList, hint: 'Protocols list', rule: (data)=>{return data.model === 'Conveyor'}},
  ]

  let statusItems = []

  let machineProps = [
    {field: 'no', ro: true, add: '', w: '20'},
    {field: 'ProductGroup', ro: true, add: '', w: '20'},
    {field: 'model', ro: true, add: '', w: '20'},

    {
      field: 'unit_serial', ro: false, add: '', w: '20',
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      field: 'sn', ro: false, add: '', w: '20',
      roles: ['ib_sales_unit', 'ib_supervisor']
    },

    {field: 'status', ro: false, add: '', w: '20', combo: true, items: statusItems},

    {
      field: 'op_speed', ro: false, add: '', w: '20', suffixRef: 'op_speed_units',
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      field: 'hours', ro: false, add: '', w: '20', number: true,
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      field: 'prod_weight', ro: false, add: '', w: '20',
      roles: ['ib_sales_unit', 'ib_supervisor']
    },
    {
      field: 'notes', ro: false, add: '', w: '32',
      roles: ['ib_sales_unit', 'ib_supervisor']
    }
    // {field: 'tech', ro: true, add: '', w: '32'},
  ]

  let _projectProps = {
    common: [
      {field: 'country_key', ro: true},

      {
        field: 'op_center', ro: true,
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'LinkedProject', ro: true,
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'GKAM', ro: true,
        roles: ['ib_sales_unit', 'ib_supervisor']
      },

      {field: 'Reference', ro: false, items: [], loading: false},
      {field: 'Email', ro: false},

      {
        field: 'sa', ro: false, check: {labels: ['No', 'Yes']},
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'sa_end', ro: false,
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'is_sat', ro: true, check: {labels: ['No', 'Yes']},
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'SATDate', ro: true,
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'AssetValue', ro: true, currency: 'Currency',
        roles: ['ib_sales_unit', 'ib_supervisor']
      },
      {
        field: 'WarrantyDate', ro: true, add: '', w: '32',
        roles: ['ib_sales_unit', 'ib_supervisor']
      }
      // {field: 'su_erp_proj', ro: true},
      // {field: 'su_erp_proj_name', ro: true},
      // {field: 'sales_unit', ro: true},
    ],
    customer: [
      {field: 'shcu_no', ro: true},
      {field: 'shcu_name', ro: true},
      {field: 'shcu_city', ro: true},
      {field: 'shcu_country', ro: true},
      {field: 'shcu_street', ro: true},
    ],
    end_user: [
      {field: 'eu_name', ro: false},
      {field: 'eu_city', ro: false, city: true, countryField: 'eu_country'},
      {field: 'eu_country', ro: false},
      {field: 'eu_address', ro: false},
    ],

    // {field: 'CustomerNo', ro: true},
    // {field: 'CustomerName', ro: true},
    // {field: 'CustomerCity', ro: true},
    // {field: 'CustomerCountry', ro: true},
    // {field: 'CustomerAddress', ro: true},

    // {field: 'p_modified', ro: true},
    // {field: 'p_modified_by', ro: true},

    // {field: 'mod', ro: true},
    // {field: 'mod_by', ro: true},
    // {field: 'created', ro: true},
    // {field: 'created_by', ro: true},
    // {field: 'lat', ro: true},
    // {field: 'lon', ro: true},
  }

  const projectPropsRoles = [
    {key: 'common', roles: ['ib_user']},
    {key: 'customer', roles: ['ib_user']},
    {key: 'end_user', roles: ['ib_sales_unit', 'ib_supervisor']}
  ];

  [...machineProps].forEach(p => {
    p.label = getLabel(p.field, 'en')
  })

  let projectProps = {common: [], customer: [], end_user: []}

  Object.keys(_projectProps).forEach(key => {
    _projectProps[key].forEach(p => {
      p.label = getLabel(p.field, 'en')
    })
  })

  $: {
    machineProps = arrayFilterByRoles(machineProps, $userStore.roles)
    let keys = arrayFilterByRoles(projectPropsRoles, $userStore.roles).map(p => p.key)
    projectProps = Object.fromEntries(
      Object.entries(
        {..._projectProps, common: arrayFilterByRoles(_projectProps.common, $userStore.roles)})
        .filter(([key, val]) => keys.includes(key))
    )
  }

  $: getContacts(edit, data)

  onMount(() => {
    // console.log('[DEBUG] editForm data', data)
    api.getMachineStatus()
      .then(res => {
        if (res.data && res.data.value && Array.isArray(res.data.value)) {
          let found = machineProps.findIndex(p => p.field === 'status')
          if (found > -1) {
            machineProps[found].items = [...res.data.value].map(p => ({text: p, value: p}))
          }
        }
      })
  })


  function actionHandler ({detail}) {
    // console.log('[DEBUG] actionHandler', detail.item)
    if (detail.action.name === 'protocols') {
      push('/condition-monitoring?id=' + detail.item.no)
      $selectedInstalledBase = {no: null}
    }
    if (detail.action.name === 'new-protocol') {
      $selectedInstalledBase = detail.item
      push('/condition-monitoring/protocol/new?machine_no=' + detail.item.no)
    }
  }

  function editHandler () {
    edit = true
    dispatch('edit', data)
  }

  function saveHandler () {
    edit = false
    dispatch('save', {project: data})
  }

  function getContacts (edit, data) {
    if (!edit || !data || data.shcu_no == null) {
      return
    }
    const referenceIndex = projectProps.common.findIndex(p => p.field === 'Reference')
    console.log('[DEBUG] getContacts reference index:', referenceIndex)

    if (referenceIndex < 0 || projectProps.common[referenceIndex].items.length > 0) {
      console.log('[DEBUG] exit from getContacts, items was:', projectProps.common[referenceIndex].items)
      return
    }
    projectProps.common[referenceIndex].loading = true
    let filter = data.shcu_no.trim()
    if (filter.substr(0, 2) === '00') {
      filter = filter.substr(2)
    }
    api.contactsByCustomer(filter)
      .then(res => {
        const newContacts = res.data.map(p => {
          return {value: p.email, text: p.lastName + ', ' + p.firstName}
        })
        console.log('[DEBUG] new contacts:', newContacts)
        projectProps.common[referenceIndex].items = newContacts
      })
      .catch(err => {
        console.log('[ERROR] getting customer contacts from FLWS', err)
      })
      .finally(() => {
        projectProps.common[referenceIndex].loading = false
      })
  }

  function sparePartsHandler () {
    console.log('[DEBUG] sparePartsHandler',)
    const path = '/spare-part-list-generator/' + encodeURIComponent(data.su_erp_proj)
    console.log('[DEBUG] path', path)
    push(path)
  }

  function conditionMonitoringHandler (data) {
    const path = '/condition-monitoring?project=' +
      encodeURIComponent(data.su_erp_proj)
    push(path)
  }

  function documentationHandler () {
    const baseLink = 'https://www.flexlink.com/en/search-page?'
    if (!data || !data.machines) {
      return
    }
    const keys = data.machines.map(m => m.ProductGroup === 'SE' ? 'spiral elevator' : m.ProductGroup)
      .reduce((a, v) => {
        return a.includes(v) ? a : [...a, v]
      }, [])
    const query = 'keys=' + encodeURIComponent(keys.join(' or '))
    const url = baseLink + query
    const win = window.open(url, '_blank')
    win.focus()
  }
</script>


{#if !data || !data.su_erp_proj}
  <div class="mx-auto inline-block text-center pt-24 h-64">
    <ProgressCircular />
  </div>
{:else}

  <div class="flex">
    <div class="w-1/3 lg:w-1/4 flex-shrink-0">
      <div class="container mx-auto">
        <div class="flex flex-col pt-8 xl:px-16 px-8">
          <RedButton trackingID={'installed_base.Generate_spare_part_list'}
                     add="w-full mb-2" text="Generate spare part list"
                     on:click={sparePartsHandler} />

          <RedButton trackingID={'installed_base.Documentation'}
                     add="w-full mb-2" text="Documentation" on:click={documentationHandler} />

          <RedButton trackingID={'installed_base.Conveyor_condition_monitoring'}
                     add="w-full mb-2" text="Conveyor condition monitoring"
                     on:click={() => conditionMonitoringHandler(data)} />

          {#if $userStore.roles.includes('sp_admin')}
            <RedButton trackingID={'installed_base.Admin_spare_parts_list'}
                       add="w-full mb-2" text="Admin Spare parts list" />
          {/if}
        </div>
      </div>
    </div>

    <div class="w-full px-6">
      <div class="text-left px-3 py-2 my-3 flex justify-between">

        {#if !edit}
          <div class="text-xl uppercase flex items-center btn" on:click={editHandler}>
            Edit
            <Icon class="ml-2">edit</Icon>
          </div>
        {:else}
          <div class="text-xl uppercase flex items-center btn" on:click={saveHandler}>
            Save
            <Icon class="ml-2">save</Icon>
          </div>
        {/if}
        <div class=" uppercase flex items-center btn" on:click={() => { dispatch('close') }}>
          <i class="material-icons icon ml-2 close-icon">close</i>
        </div>
      </div>

      <div class="text-left text-gray-600 text-lg w-full" style="min-height: 200px">
        <div class="mb-10">
          <ProjectData {data} {projectProps} {edit} />
        </div>
      </div>
    </div>

  </div>

  <div class="w-full overflow-x-auto mb-10 text-gray-700" style="max-height: 500px">
    <DataTable data={data.machines || []}
               {actions}
               actionsLabel="Conveyor condition monitoring"
               columns={machineProps}
               sortable={false}
               filterable={false}
               edit={edit}
               selectable={false}
               description="installed base"
               headerClass="bg-gray-600 text-base"
               on:action={actionHandler}
    />
  </div>
{/if}

<style>
    .grayed {
        background-color: #f4f4f4;
    }

    .btn:hover {
        cursor: pointer;
    }

    .close-icon {
        color: #a0a0a0;
        font-size: 2.0rem;
    }

    .close-icon:hover {
        color: #1d1d1d;
    }

    .input-text {
        height: 100%;
        width: 100%;
    }

    .drop-list {
        margin-top: 2px;
        max-height: 300px;
        width: 100%;
        min-width: 200px;
        max-width: 400px;
        overflow-x: hidden;
    }

    .drop-list-item:hover {
        background-color: #e0e0e0;
    }
</style>
